module.exports = __webpack_public_path__ + "assets/img/5_1176.ea99ac11.jpg";